import React from "react";
import classes from "./transactions.module.css";
import {
  PaymentIconRed,
  UserIconRed,
  StarIconRed,
  WorkingHoursRed,
  Visa,
  TransactionRedIcon,
} from "../../../../constant/imagePath";
import { Container, Row, Col, Table } from "react-bootstrap";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { ReactSVG } from "react-svg";

const Transactions = () => {
  const transactiondata = [
    {
      date: "11/13/19",
      title: "1 on 1 Tennis Lesson with John Johnson",
      cardNumber: 3679,
      price: 75,
      upcoming: true,
    },
    {
      date: "11/13/19",
      title: "1 on 1 Tennis Lesson with John Johnson",
      cardNumber: 3679,
      price: 80,
      upcoming: false,
    },
  ];
  return (
    <div className={[classes.mt32].join(" ")}>
      {transactiondata.length > 1 ? (
        <Table
          responsive
          bordered={false}
          striped={false}
          hover={false}
          className={[classes.transactionTable].join(" ")}
        >
          <thead>
            <tr>
              <th
                className={["p-0"].join(" ")}
                style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}
              >
                Date
              </th>
              <th
                className={["p-0"].join(" ")}
                style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}
              >
                Payment method
              </th>
              <th
                className={["p-0"].join(" ")}
                style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}
              >
                Total
              </th>
            </tr>
          </thead>

          <tbody>
            {transactiondata?.map((item, i) => {
              return (
                <tr
                  key={i}
                  style={{
                    borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                  }}
                >
                  <td className={["p-0", classes.py20].join(" ")}>
                    <span
                      style={{
                        ...Fonts.h7,
                        fontFamily: 'inter-600',
                        color: item.upcoming
                          ? Colors.neutralShadesOfPinkSwan
                          : Colors.neutralShadesOfNero,
                        lineHeight: "24px",
                      }}
                      className={[classes.mb4].join(" ")}
                    >
                      {item.date} {item.upcoming && <span>(Upcoming)</span>}
                    </span>
                    <p
                      style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
                    >
                      {item.title}
                    </p>
                  </td>
                  <td
                    className={["p-0", classes.py20].join(" ")}
                    style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
                  >
                    <img
                      src={Visa}
                      alt="..."
                      className={[classes.visaImg].join(" ")}
                    />
                    •••• •••• •••• {item.cardNumber}
                  </td>
                  <td
                    className={["p-0", classes.py20].join(" ")}
                    style={{
                      ...Fonts.h6,
                      color: item.upcoming
                        ? Colors.neutralShadesOfPinkSwan
                        : Colors.neutralShadesOfNero,
                    }}
                  >
                    ${item.price}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : (
        <div className={[classes.noPayoutDiv].join(" ")}>
          <div style={{ width: "428px" }}>
            <ReactSVG
              src={TransactionRedIcon}
              className={[classes.upcomingPayouts, classes.mb16].join(" ")}
            />
            <h4
              className={[classes.textcenter, classes.mb16].join(" ")}
              style={{
                ...Fonts.h4,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
              }}
            >
              You do not have any upcoming payouts
            </h4>
            <p
              className={[classes.textcenter].join(" ")}
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
            >
              Once a student has booked a lesson with you, transaction
              information will appear here.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
export default Transactions;
